import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';

const Hero = () => {
  return (
    <section id="hero" className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-gradient-hero">
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `radial-gradient(circle at 20% 50%, #16a34a 0%, transparent 50%),
                            radial-gradient(circle at 80% 20%, #22c55e 0%, transparent 40%)`,
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center space-x-2 bg-primary/10 border border-primary/30 rounded-full px-4 py-2">
              <span className="w-2 h-2 bg-primary-light rounded-full animate-pulse"></span>
              <span className="text-primary-light text-sm font-medium">Norges treningsplattform</span>
            </div>

            <div className="space-y-4">
              <h1 className="text-5xl lg:text-7xl font-black text-white font-heading leading-none tracking-tight uppercase">
                Form deg
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-accent">
                  selv
                </span>
                <span className="block text-4xl lg:text-5xl font-bold text-slate-300 normal-case">
                  – ikke bare drøm om det
                </span>
              </h1>
            </div>

            <p className="text-lg text-slate-400 leading-relaxed max-w-lg">
              Workout ON gir deg alt du trenger for å komme i form – eksklusive treningsvideoer,
              sunne kostholdsplaner og motiverende innhold. Når du vil, hvor du vil.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/s"
                className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-xl font-bold text-lg transition-all duration-200 shadow-2xl shadow-primary/30 hover:shadow-primary/50 hover:-translate-y-0.5"
              >
                Fortsett
                <ArrowRight className="w-5 h-5" />
              </a>
              <a
                href="#oppdag"
                className="inline-flex items-center justify-center gap-2 border border-border-dark hover:border-primary/50 text-slate-300 hover:text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-200"
              >
                Les mer
              </a>
            </div>

            <p className="text-xs text-slate-500 leading-relaxed max-w-lg">
              Kunden registrerer sitt mobilnummer og bekrefter registreringen og ytterligere kostnader
              ved å taste inn PIN-koden som mottas via SMS. Dette er en abonnementstjeneste som
              automatisk fornyes hver måned. For å be om at tjenesten avsluttes, kan du kontakte
              kundeservice på +4721955881 eller sende en e-post til no@workout-on.com. Transaksjonen
              vil belastes telefonregningen din eller trekkes automatisk fra forhåndsbetalt saldo. Du
              kan når som helst avslutte abonnementet ved å sende en SMS til 2210 med kodeordet WO
              STOPP. Dersom tjenesten ikke avsluttes, vil den automatisk fornyes for en måned til.
              Aldersgrensen er 18 år. Tjenesten leveres av Skillbill B.V.
            </p>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent rounded-3xl blur-3xl"></div>
              <img
                src="/images/beach_generic.png"
                alt="Treningsperson i aksjon"
                className="relative w-full rounded-3xl shadow-2xl object-cover h-[600px]"
              />
              <div className="absolute inset-0 rounded-3xl ring-1 ring-primary/20"></div>
            </div>

            <div className="absolute -bottom-6 -left-6 bg-card-dark border border-border-dark rounded-2xl p-5 shadow-2xl">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-primary/20 rounded-xl flex items-center justify-center">
                  <span className="text-2xl">🏋️</span>
                </div>
                <div>
                  <p className="text-white font-bold text-sm">10.000+ brukere</p>
                  <p className="text-slate-400 text-xs">når sine mål</p>
                </div>
              </div>
            </div>

            <div className="absolute -top-4 -right-4 bg-primary rounded-2xl px-4 py-3 shadow-2xl shadow-primary/30">
              <p className="text-white font-bold text-sm">kr 39,- / uke</p>
            </div>
          </div>
        </div>
      </div>

      <a href="#oppdag" className="absolute bottom-8 left-1/2 -translate-x-1/2 text-slate-500 hover:text-primary-light transition-colors animate-bounce">
        <ChevronDown className="w-8 h-8" />
      </a>
    </section>
  );
};

export default Hero;
